import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { BackendApiService } from 'src/app/core/services/backend-api';

export interface Attachment {
  AttachmentId: number;
  MPDocumentNumber: string;
  FileName: string;
  AttachmentTypeId: number;
  IsActive: boolean;
}

@Injectable({ providedIn: 'root' })
export class FileService {
  constructor(private backendApi: BackendApiService) {}

  async downloadAttachment(attachment: Attachment) {
    try {
      let data: any = await lastValueFrom(
        this.backendApi.downloadAttachment(
          attachment.AttachmentId?.toString() as string
        )
      );
      const arrayBuffer: any = data.attachment.data;
      const int8Array = new Uint8Array(arrayBuffer);
      let blob = new Blob([int8Array], { type: `application/json` });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(blob);
      a.download = attachment.FileName;
      a.click();
      window.URL.revokeObjectURL(a.href);
    } catch (e) {
      alert('Error downloading attachment.');
    }
  }

  async downloadFiles(
    filePaths: string[],
    options: {
      fileNames?: string[];
      isOpenInNewTab?: boolean;
      fileType?: string;
    } = {}
  ) {
    const { fileNames, isOpenInNewTab, fileType = 'application/pdf' } = options;

    if (!Array.isArray(filePaths) || filePaths.length === 0) {
      return;
    }

    const downloadFileNames =
      fileNames ??
      filePaths.map((filePath) => filePath.split('/').slice(-1)[0]);
    if (
      downloadFileNames.filter((fileName) => !!fileName).length !==
      filePaths.length
    ) {
      console.log(
        'Unable to download file(s) due to invalid file path or file name.',
        filePaths,
        downloadFileNames
      );
      alert(
        'Unable to download file(s) due to invalid file path or file name.'
      );
    }
    try {
      let response: any = await lastValueFrom(
        this.backendApi.downloadFiles(filePaths)
      );

      if (!response || !response.files || !Array.isArray(response.files)) {
        throw new Error();
      }
      for (const [index, file] of response.files.entries()) {
        const arrayBuffer: any = file.data;
        const int8Array = new Uint8Array(arrayBuffer);
        let blob = new Blob([int8Array], { type: fileType });
        const fileURL = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = downloadFileNames[index];
        a.click();
        if (isOpenInNewTab) {
          window.open(fileURL);
        }
        window.URL.revokeObjectURL(a.href);
      }
    } catch (e) {
      console.log('Error downloading file(s).', e);
      alert('Error downloading file(s).');
    }
  }

  async saveFileFromBuffer(
    fileArrayBuffer: Iterable<number>,
    options: { fileName: string; isOpenInNewTab?: boolean; fileType?: string }
  ) {
    const {
      fileName,
      isOpenInNewTab = true,
      fileType = 'application/pdf',
    } = options;

    const int8Array = new Uint8Array(fileArrayBuffer);
    let blob = new Blob([int8Array], { type: fileType });
    const fileURL = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = window.URL.createObjectURL(blob);
    a.download = fileName;
    a.click();

    if (isOpenInNewTab) {
      window.open(fileURL);
    }
    window.URL.revokeObjectURL(a.href);
  }
}